import React from "react";
import styled from "styled-components";
import { bulletIcon } from "../../assets/icons";

export default function KnowJesusCard({ data }) {
	const { step, heading, body } = data;

	return (
		<KnowJesusCardContainer>
			<div className="indicator">
				<img src={bulletIcon} alt="bullet" />
				<p>{step}</p>
			</div>
			<div className="details">
				<h4>{heading}</h4>
				{body?.map((text) => (
					<p className="text-justify">{text}</p>
				))}
			</div>
		</KnowJesusCardContainer>
	);
}

const KnowJesusCardContainer = styled.li`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	margin-bottom: 2rem;

	&:last-child {
		margin-bottom: 0;
	}

	.indicator {
		width: fit-content;
		height: fit-content;

		img {
			width: 2rem;
			height: 14px;
			margin-bottom: 0.6rem;
		}

		p {
			display: none;
		}
	}

	.details {
		h4 {
			margin-bottom: 0.5rem;
			font-weight: bold;
		}

		p {
			margin-bottom: 0 !important;
		}
	}

	@media (min-width: 768px) {
		flex-direction: row;
		justify-content: space-between;
		margin-bottom: 5rem;

		.indicator {
			img {
				margin-bottom: 0;
			}

			p {
				display: block;
				font-size: 1.2rem;
				font-weight: bold;
			}
		}

		.details {
			width: 90% !important;

			padding-top: 1.4rem;

			h4 {
				margin-bottom: 0.5rem !important;
			}

			p {
				margin-bottom: 0.5rem !important;
			}
		}
	}
`;
